import { useState } from "react";
import AdminEditUserModal from "./AdminEditUserModal";
import UserAccountSelector from "../../shared/UserAccountSelector";

const AdminFindUserDropdown = () => {
  const [selectedUserPk, setSelectedUserPk] = useState<string | null>(null);

  return (
    <div>
      <UserAccountSelector
        value={selectedUserPk}
        onChange={setSelectedUserPk}
        placeholder="Find user by name or email"
        label="Find user"
        labelClassName="font-medium"
        showDeletedOption={true}
      />
      {selectedUserPk && (
        <AdminEditUserModal
          userPk={selectedUserPk}
          setUserPk={setSelectedUserPk}
        />
      )}
    </div>
  );
};

export default AdminFindUserDropdown;
